import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import signup_banner from "../../../images/fx-rates.png";
import { Link } from "react-router-dom";
import Header from "../../Includes/Header";
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "../../Includes/Footer";
import BackButton from "../../Includes/BackButtonEntityAccount";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import config from "../../../config";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import { setEmail, setBusinessName, setwizardPageNumber, setUserID } from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError, notifyWarn, notifySuccess } from "MyComponents/Toaster";
import { AxiosError } from "axios";
import { isEmailExist, validateEmail, getUserID, getUserData, isRecaptchaVerified, isBusinessEmail } from "../../../Utils/user";
import Spinner from "react-bootstrap/Spinner";
import Spacer from "MyComponents/UI/Spacer";

interface FormData {
  businessName: string;
  email: string;
}

interface Props { }

const RegisterEntityAccount: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const page = useSelector((state: RootState) => state.entityAccount.wizardPageNumber);
  const [isChecked, setIsChecked] = useState(false);
  const [validated, setValidated] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [businessEmailError, setBusinessEmailError] = useState(false);
  const site_key: any = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [captchaValue, setCaptchaValue] = useState<string | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const recaptcha = useRef<ReCAPTCHA>(null);
  let isEmailVerified = "";
  const theme = useSelector((state: RootState) => state.theme.theme);

  const handleRecaptchaChange = (value: string | null) => {
    setCaptchaValue(value);
    if (value) setValidated(false);
  };

  const startLoading = () => setLoading(true);

  const handleChangeEmail = (e: any) => {
    if (e.target.value) {
      setEmailValidation(false);
      setBusinessEmailError(false);
    }
  };

  const handleEmailBlur = (e: any) => {
    const email = e.target.value;
    if (email) {
      const isBusiness = isBusinessEmail(email);
      setBusinessEmailError(!isBusiness);
    }
  };

  const validateBusinessName = (value: string) => {
    if (!value || !value.trim()) {
      return t('register.business_name_required');
    }
  };

  const registerMiniOverridePassword = async (email: string) => {
    const checkEmail = await axios.post(config.NODE_API_BASE_URL + "/wso2/registerMiniOverridePassword", { email });
    return checkEmail.data;
  };

  const handleCheckboxChange = (e: any) => setIsChecked(e.target.checked);

  useEffect(() => {
    if (isEmailVerified == "1") setEmailValidation(true);
  }, [isEmailVerified]);

  const submitForm = async (formValues: FormData) => {
    setIsSubmitted(true);
    const email = formValues.email;
    const businessName = formValues.businessName;

    const isBusiness = isBusinessEmail(email);
    if (!isBusiness) {
      setBusinessEmailError(true);
      notifyError("Please use a business email address");
      setIsSubmitted(false);
      return;
    }

    const captchaValue = recaptcha.current?.getValue();
    if (!captchaValue) {
      setValidated(true);
      setIsSubmitted(false);
      return;
    }
    startLoading();

    const recaptchaResponse = await isRecaptchaVerified(captchaValue);
    if (!recaptchaResponse) {
      notifyError("Recaptcha Failed");
      setValidated(true);
      setLoading(false);
      setIsSubmitted(false);
      return;
    }

    const emailStatus = await isEmailExist(email);
    if (emailStatus.isEmailExist) {
      if (emailStatus.isVerified == "1") {
        setEmailValidation(true);
        setLoading(false);
        setIsSubmitted(false);
      } else {
        setEmailValidation(false);
        registerMiniOverridePassword(email);
        dispatch(setEmail(email));
        dispatch(setBusinessName(businessName));
        dispatch(setUserID(emailStatus.userId));
        dispatch(setwizardPageNumber(page + 2));
        setLoading(false);
        setIsSubmitted(false);
      }
    } else {
      dispatch(setEmail(email));
      dispatch(setBusinessName(businessName));
      dispatch(setwizardPageNumber(page + 1));
      setLoading(false);
      setIsSubmitted(false);
    }
  };

  return (
    <>
      <ToastBox />
      <Container fluid className="px-0 flex-grow-1 d-flex flex-column">
        <Row className="g-0 flex-grow-1">
          <Col md={6} className="px-3 px-md-5 py-4">
            <div className="mt-5">
              <h4 className="text-primary mt-3 mb-4 fw-semibold">
                {t('register.create_entity_title')}
              </h4>
              <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                <div className="mb-3 me-md-5 col-md-10" style={{ maxWidth: "480px" }}>
                  <label htmlFor="businessName" className="form-label">
                    {t('register.business_name_label')}
                  </label>
                  <Field
                    name="businessName"
                    type="text"
                    component={renderField}
                    className="form-control rounded-5"
                    placeholder={t('register.enter_business_name_ph')}
                    id="businessName"
                    validate={validateBusinessName}
                  />
                </div>
                <div className="mb-3 me-md-5 col-md-10" style={{ maxWidth: "480px" }}>
                  <label htmlFor="email" className="form-label">
                    {t('register.business_email')}
                  </label>
                  <Field
                    name="email"
                    type="email"
                    component={renderField}
                    className="form-control rounded-5"
                    placeholder={t('register.enter_email_ph')}
                    id="email"
                    validate={validateEmail}
                    onChange={handleChangeEmail}
                    onBlur={handleEmailBlur}
                  />
                  <>
                    {emailValidation && (
                      <p className="text-danger text-start small fw-bold">{t('register.email_already_exist')}</p>
                    )}
                    {businessEmailError && (
                      <p className="text-danger text-start small fw-bold">{t('register.business_email_error')}</p>
                    )}
                  </>
                </div>
                <div className="mb-2">
                  <Form.Check
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    className={`text-secondary small ${!isChecked && isSubmitted ? "reg-checkbox border-danger" : ""}`}
                    label={
                      <span>
                        {t('common.terms_agree')}{" "}
                        <Link className="text-primary" to={"/terms-of-service"} target="_blank">
                          {t('common.terms_of_service')}
                        </Link>{" "}
                        {t('common.and')}{" "}
                        <Link className="text-primary" to={"/privacy-policy"} target="_blank">
                          {t('common.privacy_policy')}
                        </Link>
                        .
                      </span>
                    }
                  />
                </div>
                <div className="form-check mb-2">
                  <input type="checkbox" className="form-check-input" id="marketing_emails" value="1" />
                  <label className="form-check-label text-secondary small" htmlFor="check2">
                    {t('common.marketing_agree')}
                  </label>
                </div>
                <div className="mt-4 mb-3">
                  <ReCAPTCHA ref={recaptcha} sitekey={site_key} onChange={handleRecaptchaChange} />
                </div>
                <>
                  {(!isChecked || validated) && isSubmitted && (
                    <p className="text-danger text-start small fw-bold">
                      {!isChecked && isSubmitted
                        ? t('register.terms_required')
                        : t('register.recaptcha_required')}
                    </p>
                  )}
                </>
                <Button
                  variant="primary"
                  type="submit"
                  className="btn btn-primary rounded-5 mt-2"
                  disabled={loading || !captchaValue || !isChecked || emailValidation || businessEmailError}
                >
                  {loading && (
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mx-2" />
                  )}
                  <span>{t('register.create_entity_btn')}</span>
                </Button>
              </Form>
              <Row className="mt-4 mb-5">
                <Col md={12}>
                  <span>
                    {t('register.not_entity')}&nbsp;
                    <Link className="text-primary" to={"/onboarding"}>
                      {t('register.register_personal_link')}
                    </Link>
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={6} className={`d-none d-md-block text-center ${theme === "light" ? "bg-sky" : "bg-dark-solid shadow-sm"}`}>
            <Spacer height="120px" />
            <img src={signup_banner} className="img-fluid" style={{ maxWidth: 500, width: "100%" }} alt="banner" />
            <Spacer height="50px" />
            <h2 className="trade-confidence">{t('common.all_in_one')}</h2>
            <p className="text-secondary">{t('common.all_in_one_desc')}</p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    businessName: state.entityAccount.businessName || "",
    email: state.entityAccount.email || "",
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "entityWizard",
  enableReinitialize: true,
})(RegisterEntityAccount);

export default connect(mapStateToProps)(form);
